require([
	'jquery',
	'base/MbiHelper',
	'project/MbiConfig',
	'base/MbiMediaQuery',
	'base/MbiImageSize'

], function($,
	_,
	mbiConfig,
	mbiMq,
	mbiImageSize

) {
	'use strict';

	if ($('.js_tabs_parent').length >= 1) {

		mbiConfig.urls = {assets : ASSETS_URL};

		var location = window.history.location || window.location;

		var module = {
			loadLocationButtonClass: 	'js_tab',
			supportHistory:					true, // @todo: use this to determine if history is supported
			googleMaps: null,
			activeTab: false,
			lockButtons: function() {
			},
			unlockButtons: function() {
			},
			init: function() {

				// document.body.scrollTop = document.documentElement.scrollTop = 0;
				var $loadLocationButton = $('.'+module.loadLocationButtonClass),
					hash = '';

				if (location.hash) {
					hash = location.hash.slice(1);
					$loadLocationButton.each(function(){
						if ($(this).attr('data-name') === hash) {
							module.onClickLoadLocationButton(this);
							module.activeTab = true;
						}
					});
				}

				if (!module.activeTab) {
					hash = $loadLocationButton.first().attr('data-name');
					window.location.href = location.href + '#' + hash;
				}

				document.body.scrollTop = document.documentElement.scrollTop = 0;

				//check if history.js is supported
				if (window.history && window.history.pushState) {
					module.supportHistory = true;
				} else {
					module.supportHistory = false;
				}
				module.clickHandler();

				if(module.supportHistory) {
					if(_.exists('.'+module.loadLocationButtonClass)) {

						var state = {
							'tabIndex': false,
							'scrollTop': $(window).scrollTop()
						};
						window.history.replaceState(state, null, location.href);
					}
				}
			},
			updateLocationHash: function(location, hash) {
				return location.href.replace(location.hash, '#'+hash);
			},
			clickHandler: function() {
				$(document).on('click', '.'+module.loadLocationButtonClass, function(e) {
					e.preventDefault();
					if(!$(this).hasClass('is_locked')) {
						module.lockButtons();
						module.onClickLoadLocationButton(this);
					}
				});
			},
			onClickLoadLocationButton: function(that) {

				var $this = $(that),
					$container = $this.parents('.js_tabs_parent'),
					$nav = $container.find('.js_tabs_nav'),
					tabIndex = $this.attr('data-index'),
					tabName = $this.attr('data-name'),
					$content = $container.find('.js_tab_content[data-index="' + tabIndex + '"]');

					$nav.removeClass('is_open');

					if (!($this.hasClass('is_active'))) {

						var $selection = $nav.find('.js_tabs__selection div');
						$selection.html($this.find('span').html());

						$('.js_tab').removeClass('is_active');
						$this.addClass('is_active');

						$('.js_tab_content').removeClass('is_current');
						$content.addClass('is_current');
						$('.js_tab_content.is_current').addClass('fade');

						setTimeout(function() {
							if ($content.find('.mapCanvas').length > 0) {
								var $mapCanvas = $content.find('.mapCanvas'),
									id = $mapCanvas.attr('id'),
									longitude = parseFloat($mapCanvas.attr('data-longitude')),
									latitude = parseFloat($mapCanvas.attr('data-latitude'));

								module.loadMap(id, latitude, longitude, false);
							}
						}, 100);

						setTimeout(function() {
							if ($content.find('.mapCanvas').length > 0) {
								var fireRefreshEventOnWindow = function () {
									var evt = document.createEvent("HTMLEvents");
									evt.initEvent('resize', true, false);
									window.dispatchEvent(evt);
								};
								fireRefreshEventOnWindow();
							}
						}, 250);

						// setTimeout(function() {
							$(document).on('click', '.js-posts-nav', function () {
								console.info('js-posts-nav click');
								console.info( $('.hidden-job').length );
								console.info( $(this) );
								$('.hidden-job').slideDown('fast');
								$(this).slideUp('fast');
							});
						// }, 300);
					}

					var url = module.updateLocationHash(location, tabName);
					window.location.href = url;
					document.body.scrollTop = document.documentElement.scrollTop = 0;

			},
			loadMap: function(canvasID, latitude, longitude, initial) {
					var initGoogleMaps;
					var styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
								var markerClickedHandler = function(marker, address) {

								};

								//change to correct marker
								var customMarkerURL = mbiConfig.urls.assets + "/Images/herz.svg";



								// _.log('lap-' in mbiMq.mqArea);

								var isDraggable         = true;
								var isNavigationControl = true;
								var isScaleControl      = true;
								var isPanControl        = true;
								var isZoomControl       = false;

								if ('pad-' in mbiMq.mqArea) {
									isDraggable         = false;
									isNavigationControl = false;
									isScaleControl      = false;
									isPanControl        = false;
									isZoomControl       = false;
								}

					var args = {

						center: {
							latitude: latitude,
							langtitude: longitude
						},
						mapOptions: {

							zoom: 11,
							center: mapcenter,
							fullscreenControl: true,
							scrollwheel: false,
							mapTypeControl: false,
							navigationControl: isNavigationControl,
							scaleControl: isScaleControl,
							panControl: isPanControl,
							zoomControl: isZoomControl,
							streetViewControl: false,
							draggable: isDraggable,
							mapTypeId: 'ROADMAP',
							styles: styles

						},
						extraOptions: {

							mapCanvasID: canvasID,
							// markerIconUrl: 'http://imac16/GartenrastAt' + customMarkerURL,
							markerIconUrl: customMarkerURL,
							markerIconWidth: 32,
							markerIconHeight: 32,
							markerCurrentLocationIconUrl: customMarkerURL,
							markerCurrentLocationIconWidth: 32,
							markerCurrentLocationIconHeight: 32,
							markerPath: 'CIRCLE', // path can be google.maps.SymbolPath.{BACKWARD_CLOSED_ARROW/BACKWARD_OPEN_ARROW/CIRCLE/FORWARD_CLOSED_ARROW/FORWARD_OPEN_ARROW} or SVG path notation
							showAll: false,
							maxZoomIn: 16,
							maxZoomOut: 16,

							markerClickCallback: markerClickedHandler
						}

					};

					if (initial) {

						require(['project/MbiGoogleMaps'], function(mbiGoogleMaps) {

							initGoogleMaps = function(canvasID, latitude, longitude) {
								var mapcenter = new google.maps.LatLng(latitude, longitude);

								args.mapOptions.center = mapcenter;

								mbiGoogleMaps.init(args);
								var address={
									lat: latitude,
									lng: longitude,
									elementID:canvasID
								};
								var marker = mbiGoogleMaps.createLocationMarker(canvasID,address);
								module.googleMaps = mbiGoogleMaps;


							};
							initGoogleMaps(canvasID,latitude,longitude);

						});

					} else {

						var address={
								lat: latitude,
								lng: longitude,
								elementID:canvasID
							};

						var mapcenter = new google.maps.LatLng(latitude, longitude);

						args.mapOptions.center = mapcenter;

						module.googleMaps.init(args);;

						var marker = module.googleMaps.createLocationMarker(canvasID,address);

					}

			}
		};

		module.init();
		if (_.exists('.mapCanvas')) {
			var $mapCanvas = $('.mapCanvas');

				$mapCanvas.each(function(){
					if ($(this).attr('id') === location.hash.slice(1)) {
						var id = $(this).attr('id'),
						longitude = parseFloat($(this).attr('data-longitude')),
						latitude = parseFloat($(this).attr('data-latitude'));

						module.loadMap(id, latitude, longitude, true);
					}
				});

		}

	}

});
define("root/Assets/Templates/Html/Locations/Js/Locations", function(){});

